import React, { useCallback, useState } from "react";
import { send } from "emailjs-com";
import emailConfig from "../../assets/email";
import {
  Wrapper,
  ContactsWrapper,
  FormWrapper,
  Form,
  Input,
  Button,
  Contact,
  Contacts,
  H2,
} from "./elements";
import { H1 } from "../../components/sharedElements";
import LetterImg from "../../assets/images/letter.svg";
import TextArea from "../../components/TextArea";
import { Modal1, Modal1Header } from "../../components/modal";

const validateField = (key, value) => {
  if (key === "name") return value.length > 2;
  if (key === "email") return /.+@.*\..+/.test(value);
  if (key === "question") return value.split(" ").length > 2;
};

const ContactUs = () => {
  const [formFields, setFormFields] = useState({
    firstName: "",
    lastName: "",
    email: "",
    question: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = useCallback(() => setIsModalOpen(false), []);
  const [feedback, setFeedback] = useState({
    text: "",
    success: true,
    sending: false,
  });
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      setFeedback({
        text: "",
        success: true,
        sending: true,
      });
      send(
        emailConfig.SERVICE_ID,
        emailConfig.TEMPLATE_ID,
        formFields,
        emailConfig.USER_ID
      )
        .then(() => {
          setFeedback({
            text: "Thank you for reaching to us",
            success: true,
            sending: false,
          });
          setFormFields({
            firstName: "",
            lastName: "",
            email: "",
            question: "",
          });
          setIsModalOpen(true);
        })
        .catch(() => {
          setFeedback({
            text: "Error sending message",
            success: false,
            sending: false,
          });
          setIsModalOpen(true);
        });
    },
    [formFields]
  );

  const updateField = useCallback((e) => {
    if (e.target.id === "firstName")
      return setFormFields((o) => ({ ...o, firstName: e.target.value }));
    if (e.target.id === "lastName")
      return setFormFields((o) => ({ ...o, lastName: e.target.value }));
    if (e.target.id === "email")
      return setFormFields((o) => ({ ...o, email: e.target.value }));
    if (e.target.id === "question")
      return setFormFields((o) => ({ ...o, question: e.target.value }));
  }, []);

  const validity = {
    firstName: validateField("name", formFields.firstName),
    lastName: validateField("name", formFields.lastName),
    email: validateField("email", formFields.email),
    question: validateField("question", formFields.question),
  };

  return (
    <>
      <Wrapper >
        <H1 >Get to us</H1>
        <FormWrapper >
          <img src={LetterImg} alt="letter" />
          <Form onSubmit={handleSubmit} >
            <Input
              type="text"
              id="firstName"
              valid={validity.firstName}
              placeholder="First Name"
              value={formFields.firstName}
              onChange={updateField}
            />
            <Input
              type="text"
              id="lastName"
              valid={validity.lastName}
              placeholder="Last Name"
              value={formFields.lastName}
              onChange={updateField}
            />
            <Input
              type="email"
              id="email"
              valid={validity.email}
              placeholder="Email"
              value={formFields.email}
              onChange={updateField}
            />
            <TextArea
              id="question"
              valid={validity.question}
              placeholder="Your Qeustion"
              rows={5}
              value={formFields.question}
              onChange={updateField}
            />
            <Button
              disabled={
                !Object.values(validity).every((v) => v) || feedback.sending
              }
            >
              {feedback.sending ? "Sending Message..." : "Send Message"}
            </Button>
          </Form>
        </FormWrapper>
        <ContactsWrapper >
          <H2 >Our Address</H2>
          <Contacts >
            <Contact>
              <i className="fas fa-map-marker-alt" />
              <p>Bahria Town, Islamabad, Pakistan</p>
            </Contact>
            <Contact>
              <i className="fas fa-phone" />
              <a href="tel:+923001234567">(+92) 300 1234567</a>
            </Contact>
            <Contact>
              <i className="fas fa-envelope" />
              <a href="mailto:mail.to@mail.com">mail.to@mail.com</a>
            </Contact>
            <Contact>
              <i className="fab fa-whatsapp" />
              <a href="https://api.whatsapp.com/send?phone=923001234567&text=Hi">
                (+92) 300 1234567
              </a>
            </Contact>
          </Contacts>
        </ContactsWrapper>
      </Wrapper>
      <Modal1 isOpen={isModalOpen} toggle={toggleModal}>
        <Modal1Header toggle={toggleModal} success={feedback.success}>
          {feedback.text}
        </Modal1Header>
      </Modal1>
    </>
  );
};

export default ContactUs;
